(function ($) {

  if ($('.node--bg-style-homepage').length) {

    // let tabVisible = false;
    const ripplesArea = $('.node--bg-style-homepage').first();

    $(document).ready(function() {
      if(ripplesArea.length) {

        // ripplesArea.ripples({
        //   interactive: false
        // });

        setTimeout(function() {
          ripplesArea.ripples({
            resolution: 512,
            dropRadius: 20,
            perturbance: 0.05,
            interactive: false,
          });
        }, 3000);

        let dropping = setInterval(function () {
            drop();
        }, 4000);

        function drop() {
          console.log('dropping');
          const x = Math.random() * -200;
          const y = Math.random() * 1000;
          //console.log('dropping', x, y);
          ripplesArea.ripples('drop', -500, y, 50, 0.05);
        }
      }
    });
  }

  // smooth scroll anchor tags
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      let _scrollToTarget = $(this.getAttribute('href'));
      let _scrollToTop = _scrollToTarget.offset().top - 150;
      // document.querySelector(this.getAttribute('href')).scrollIntoView({
      //   behavior: 'smooth', block: 'start'
      // });
      window.scrollTo({top: _scrollToTop, behavior: 'smooth'})
    });
  });

  $('.stories__video-thumb').not('.no-video').on('click', function () {
    $(this).fadeOut();
  });

  $('article .body img').each(function () {
    let _this = $(this);
    let alt = _this.attr('alt');
    let caption = _this.attr('data-caption');

    _this.wrap('<figure></figure>');

    if(caption) {
      $('<figcaption>' + caption + '</figcaption>').insertAfter(_this);
    }
    else {
      $('<figcaption>' + alt + '</figcaption>').insertAfter(_this);
    }
  });

  // $('.latest-update-list .card--event-card').attr('data-aos', 'fade-up');


  $(document).ready(function() {

    AOS.init({
      // Global settings:
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
      initClassName: 'aos-init', // class applied after initialization
      animatedClassName: 'aos-animate', // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
      disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 0, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 400, // values from 0 to 3000, with step 50ms
      easing: 'ease', // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
    });
  });

})(jQuery);
